// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"17c0df9e","239":"24874279","453":"a1227a56","732":"e5d5af48"}[chunkId] + ".chunk.js";
};